import appRides from "../../views/appRoutes/rides.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "rides";
  const params = [
    "page",
    "limit",
    "status",
    "category",
    "start_date",
    "end_date",
    "date",
    "route",
    "sort",
    "captain",
    "arrived_first_station",
    "has_bookings",
    "captain_assigned",
    "is_vendor_assigned",
    "is_dynamic",
    "event",
    "private_bus_request",
  ];

  $stateProvider.state("rides", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appRides,
      },
    },
    reloadOnSearch: false,
    data: { title: "Rides" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/rides/rides.urls.js